"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * @phrospr/backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.6.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseIWorkOrderTypeEntity = void 0;
const iwork_order_type_data_entity_1 = require("./iwork-order-type-data-entity");
function parseIWorkOrderTypeEntity(data) {
    if (data.data !== null && typeof data.data === 'object')
        data.data = (0, iwork_order_type_data_entity_1.parseIWorkOrderTypeDataEntity)(data.data);
    return data;
}
exports.parseIWorkOrderTypeEntity = parseIWorkOrderTypeEntity;
